import React, { useState } from 'react'
import axios from 'axios';
import "../Payment.css";
import { Navigate, useNavigate } from "react-router-dom";
import { decodeToken } from "react-jwt";

function Dashboard() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const token = localStorage.getItem("access_token");
    const decodedToken = decodeToken(token);
    const { REACT_APP_API_URL } = process.env;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const userData = await axios.post(`${REACT_APP_API_URL}/login`,
                {
                    username,
                    password,
                },
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    }
                }
            );
            if (userData.status === 200) {
                localStorage.setItem("access_token", userData.data);
                return navigate("/bangashpanel/products/");
            }
        } catch (e) {
            setMessage("Inavlid credentials");
            console.log(`error: ${e}`);
        }
    };

    if (decodedToken === null) {
        return (
            <div className="centered">
                <div className="container narrow-container">
                    <div className="username-section">
                        <div className="username-box">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="form-fields">
                                    <p>{message}</p>
                                    <input type="text" className="field" onChange={(e) => setUsername(e.target.value)} />
                                    <input type="password" className="field" onChange={(e) => setPassword(e.target.value)} />
                                    <input className="login-btn" type="submit" value="LOGIN" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (<Navigate to="/bangashpanel/products" />)
    }
}

export default Dashboard